<template>
  <FormSubmitPopup
      v-if="detailToggle"
      :title="$t('labelDetail')"
      v-model="detailToggle"
      hideRgtBtn
      @popupClose="() => { detailToggle = false }"
      small>
      <template v-slot:input>
      <v-tabs
        color="transparent"
        v-model="tab"
        show-arrows
      >
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab v-for="tabItem in tabs" :key="tabItem">
            {{ tabItem }}
          </v-tab>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item>
              <v-data-table
                :headers="headers"
                :items="packageStatItems"
                hide-actions
                class="elevation-1"
                item-key="index"
              >
                <template v-slot:items="props">
                  <td >{{ shipmentLabel.pricingOption === 'ONE_RATE'? shipmentLabel.packageType : props.item.packaging }}</td>
                  <td >{{ props.item.weight }}</td>
                  <td >{{ props.item.memo || shipmentLabel.memo }}</td>
                  <td class="subheading">{{ props.item.qty }}</td>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item v-if="showTrackingNumbers">
              <v-chip
                v-for="trackingNumber in (shipmentLabel.trackingNumbers || [])"
                :key="trackingNumber"
              >
                {{ trackingNumber }}
              </v-chip>
            </v-tab-item>
            <v-tab-item v-if="showAmountDetails">
              <v-data-table
                :headers="amountDetailsHeaders"
                :items="amountDetailsItems"
                hide-actions
                class="elevation-1"
                item-key="index"
              >
                <template v-slot:items="props">
                  <td >{{ props.item.name }}</td>
                  <td >{{ props.item.value }}</td>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
      </v-tabs>
      </template>
    </FormSubmitPopup>
</template>

<script>
import { PRICING_OPTIONS } from '@/utils/const'
import FormSubmitPopup from './FormSubmitPopup'
export default {
  name: 'LabelDetailPopup',
  components: {
    FormSubmitPopup
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shipmentLabel: {
      type: Object,
      default: () => {}
    },
    isFedexMWT: {
      type: Boolean,
      default: false
    },
    isSingleFile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('packaging'), value: 'packaging', align: 'left', sortable: false },
        { text: this.$t('weight'), value: 'weight', align: 'left', sortable: false },
        { text: this.$t('memo'), value: 'memo', align: 'left', sortable: false },
        { text: this.$t('qty'), value: 'qty', align: 'left', sortable: false }
      ]
    },
    detailToggle: {
      get () {
        return this.value
      },
      set (value) {
        return this.$emit('input', value)
      }
    },
    packageStatItems () {
      const itemsMap = {}
      if (this.isSingleFile || this.isFedexMWT) {
        for (const pkg of (this.shipmentLabel.packages || [])) {
          const {
            isMeasurementMetric,
            height,
            width,
            length,
            weight: pkgWeight,
            originHeight,
            originLength,
            originWeight,
            originWidth,
            qty = 1,
            memo,
            isOz } = pkg
          const packaging = `${isMeasurementMetric ? originLength : length} * ${isMeasurementMetric ? originWidth : width} * ${isMeasurementMetric ? originHeight : height} (${isMeasurementMetric ? 'cm' : 'inch'})`
          const weight = `${isMeasurementMetric ? originWeight : pkgWeight} (${isMeasurementMetric ? 'kg' : (isOz ? 'oz' : 'lbs')})`
          const key = `${packaging}---${weight}---${memo || ''}`
          itemsMap[key] || (itemsMap[key] = 0)
          itemsMap[key] += (this.isFedexMWT || this.isSingleFile) ? qty : 1
        }
      }
      return Object.entries(itemsMap).map(([key, qty]) => {
        const [packaging, weight, memo] = key.split('---')
        return {
          packaging,
          weight,
          memo,
          qty
        }
      })
    },
    tabs () {
      const tabs = [this.$t('package')]
      this.showTrackingNumbers && tabs.push(this.$t('trackingNumber'))
      this.showAmountDetails && tabs.push(this.$t('amountDetails'))
      return tabs
    },
    showTrackingNumbers () {
      return (this.isFedexMWT || this.isSingleFile) && this.shipmentLabel.status !== 'pending'
    },
    showAmountDetails () {
      return false // && Boolean(this.shipmentLabel.amountDetails)
    },
    amountDetailsHeaders () {
      return [
        { text: this.$t('name'), value: 'name', align: 'left', sortable: false },
        { text: this.$t('amount'), value: 'value', align: 'left', sortable: false }
      ]
    },
    amountDetailsItems () {
      return Object.keys(this.shipmentLabel.amountDetails).map(key => {
        return {
          name: key,
          value: this.shipmentLabel.amountDetails[key]
        }
      })
    }
  },
  data () {
    return {
      tab: 0,
      PRICING_OPTIONS
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LabelDetailPopup.vue